export default "__VITE_ASSET__a2696b2a__"